import { AfterViewInit, Component, ComponentRef, ElementRef, Input, ViewChild, ViewContainerRef } from "@angular/core";
import { PreviewItemComponent } from "@ponder-shared/previewItem/preview-item.component";
import { FilteredPreviewItem } from "@ponder-shared/tools/filter/filtered-preview-item";
import { VirtualGridOptions } from "./virtual-grid-options";

/**
 * TODO
 * 
 * 1. Get notified when a row either becomes visible or not visible via an Intersection Observer
 * https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
 * 
 * 2. Move the row via absolute position according to page movement
 * 3. Update cards being shown
 */

@Component({
    selector: "virtual-grid-row",
    imports: [],
    templateUrl: "./virtual-grid-row.component.html"
})
export class VirtualGridRowComponent implements AfterViewInit {
    @Input({ required: true }) public options!: VirtualGridOptions;
    @Input({ required: true }) public items!: FilteredPreviewItem[];
    @Input({ required: true }) public relativeRowIndex: number = -1;
    @Input({ required: true }) public currRowIndex: number = -1;

    @ViewChild("virtualGridRowItems", { read: ViewContainerRef }) private virtualGridRowItemsVcr!: ViewContainerRef;

    private isReady: boolean = false;
    private rowItems: ComponentRef<PreviewItemComponent>[] = [];

    public constructor(private element: ElementRef) {

    }

    public ngAfterViewInit(): void {
        this.isReady = true;
        this.triggerRebuild();
    }

    public triggerRebuild(): void {
        if (!this.isReady) {
            return;
        }

        this.resizeRow();
        this.repopulateRow();
    }

    private resizeRow(): void {
        // Add items / columns
        while (this.rowItems.length < this.items.length) {
            var previewItemRef = this.virtualGridRowItemsVcr.createComponent(PreviewItemComponent);
            previewItemRef.instance.isCollection = this.options?.isOwnCollection ?? false;
            
            this.rowItems.push(previewItemRef);
        }

        // Remove extra items / columns
        while (this.rowItems.length > this.items.length) {
            this.rowItems.pop();
            this.virtualGridRowItemsVcr.remove();
        }
    }

    public repopulateRow(): void {
        for (let i = 0; i < this.items.length; ++i) {
            this.rowItems[i].instance.setPreviewItem(this.items[i].previewItem);
        }
    }

    public updateCurrentRow(index: number, height: number, force: boolean = false): void {
        if (!force && this.currRowIndex == index) {
            return;
        }

        this.currRowIndex = index;
        this.element.nativeElement.style.position = "absolute";
        this.element.nativeElement.style.top = `${index * height}px`;
        this.element.nativeElement.style.left = "0px";
    }
}